import { Badge } from '@/components/ui/badge'

const sentimentConfig = {
    1: { variant: 'default', label: 'positive', className: 'tw:bg-green-600 tw:text-white' },
    '-1': { variant: 'destructive', label: 'negative', className: '' },
    0: { variant: 'secondary', label: 'neutral', className: 'tw:bg-yellow-500 tw:text-white' },
}

const Sentiment = ({ feed, style }) => {
    if (feed.sentiment === null) return null
    const config = sentimentConfig[feed.sentiment] ?? sentimentConfig[0]
    return (
        <span className="tw:me-2" style={style}>
            <Badge variant={config.variant} className={config.className}>
                {config.label}
            </Badge>
        </span>
    )
}

export default Sentiment
